import React, { useCallback } from "react";
import { connect } from "react-redux";

import Loader from "App/common/ui/Loader";
import Empty from "./Empty";
import { epocToDate, sortArray } from "utils";
import { ReactComponent as EmailIcon } from "assets/images/app_svg/activities/email.svg";
import { ReactComponent as ProfileIcon } from "assets/images/app_svg/activities/profile.svg";
import { ReactComponent as LogoutIcon } from "assets/images/app_svg/activities/logout.svg";
import { ReactComponent as LoginIcon } from "assets/images/app_svg/activities/login.svg";
import Tooltip from "App/common/ui/Tooltip";

function Body(props) {
  let logs = null;

  const iconForLog = useCallback(activityType => {
    switch (activityType) {
      case "LOGIN":
        return [LoginIcon, "logged_in"];
      case "USER_LOGOUT":
        return [LogoutIcon, "logged_out"];
      case "PASSWORD_UPDATE":
      case "PROFILE_UPDATE":
      case "UPGRADE":
      case "UPDATECC":
        return [ProfileIcon, "profile_update"];
      case "EMAIL_UPDATE":
        return [EmailIcon, "email_update"];
      default:
        return;
    }
  }, []);

  if (props.activities.loading) logs = <Loader />;
  else if (props.activities.list.length === 0) logs = <Empty />;
  else
    logs = (
      <ul>
        {sortArray(props.activities.list, "date", props.sortByDate).map(
          (log, index) => {
            const [Icon, iconClass] = iconForLog(log.audit.activityName);
            const des = log.description.includes("Email")
              ? [
                  log.description.split(/ from | to /g)[0] + " from ",
                  <strong>{log.description.split(/ from | to /g)[1]}</strong>,
                  " to ",
                  <strong>{log.description.split(/ from | to /g)[2]}</strong>
                ]
              : log.description;

            return (
              <li key={index}>
                <div className={"web_logs_item " + iconClass}>
                  <div className="web_logs_des">
                    <div className="sicon">
                      <Icon />
                    </div>
                    {Array.isArray(des) ? (
                      <React.Fragment>
                        {/* {des[0]} */}

                        <Tooltip title={des.slice(1)} placment="top">
                          <span>{des}</span>
                        </Tooltip>
                      </React.Fragment>
                    ) : (
                      des
                    )}
                  </div>
                  <div className="web_logs_when">
                    {epocToDate(log.date, "MMM d yyyy, hh:mm:ss")}
                  </div>
                  <div className="web_logs_ip">{log.remoteAddress}</div>
                </div>
              </li>
            );
          }
        )}
      </ul>
    );

  return <div className="web_logs_body is_relative">{logs}</div>;
}

function mapStateToProps(state) {
  return {
    activities: state.activities
  };
}

export default connect(mapStateToProps)(Body);
